import { useState, useEffect, useMemo } from "react";
import { FaChevronRight } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import SelectWelcomeGift from "../../components/Host/SelectWelcomeGift";
import { showError } from "../../utils/toast";
import { removeBaseUrl } from "../../utils/helpers";
import { CreateWelcomeMessage, UpdateWelcomeMessage, GetWelcomeMessage, GetWelcomeSignedUrl, uploadMultipleFilesToSignedUrls } from "../../services/api";

export default function WelcomeMessage() {
    const [media, setMedia] = useState([]);
    const [mediaType, setMediaType] = useState(null);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedCoin, setSelectedCoin] = useState(null);
    const [showCoinSelection, setshowCoinSelection] = useState(false);

    const [messageId, setMessageId] = useState("");
    const [initialData, setInitialData] = useState(null);

    const maxChars = 135;

    useEffect(() => {
        fetchWelcomeMessage();
    }, []);

    const handleMediaAdd = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        // Remaining slots
        const remaining = 4 - media.length;
        if (remaining <= 0) return;

        const selectedFiles = files.slice(0, remaining);

        // Detect type of newly selected files
        const firstFileType = selectedFiles[0].type.startsWith("image")
            ? "image"
            : selectedFiles[0].type.startsWith("video")
                ? "video"
                : null;

        if (!firstFileType) return;

        // If mediaType already exists, prevent mixing
        if (mediaType && mediaType !== firstFileType) {
            showError(`You can only select ${mediaType}s`);
            return;
        }

        // Ensure all selected files are same type
        const isSameType = selectedFiles.every(file =>
            file.type.startsWith(firstFileType)
        );

        if (!isSameType) {
            showError("All files must be of the same type");
            return;
        }

        const newMedia = selectedFiles.map(file => ({
            file,
            url: URL.createObjectURL(file),
            type: file.type.startsWith("image") ? "image" : "video",
            isUploaded: false
        }));

        setMedia(prev => [...prev, ...newMedia]);
        setMediaType(firstFileType);

        // Reset input so same file can be selected again if needed
        e.target.value = "";
    };

    const removeMedia = (index) => {
        URL.revokeObjectURL(media[index].url);

        const updated = media.filter((_, i) => i !== index);
        setMedia(updated);

        if (updated.length === 0) {
            setMediaType(null);
        }
    };

    const OnSelectClick = () => {
        setshowCoinSelection(true);
    };

    const OnCoinSelected = (coin) => {
        setSelectedCoin(coin);
        setshowCoinSelection(false);
    };

    const OnSaveClick = async () => {
        try {
            if (!media.length) return;

            const existingMedia = media.filter(m => m.isUploaded);
            const newMedia = media.filter(m => !m.isUploaded);

            console.log("Media ", media.map(m => m.file));

            let uploadedMedia = [];

            if (newMedia.length > 0) {
                // 1️⃣ Request signed URLs
                const res = await GetWelcomeSignedUrl(mediaType, newMedia.length);
                const signedData = res.data;

                console.log("Signed Url ", signedData);

                console.log("New Media ", newMedia.map(m => m.file));

                // 2️⃣ Upload all files to signed URLs
                const uploadRes = await uploadMultipleFilesToSignedUrls(
                    signedData.map(d => d.signedUrl),
                    newMedia.map(m => m.file)
                );

                console.log("Welcome Message file uploaded ", uploadRes.data);

                uploadedMedia = signedData.map(d => ({
                    type: mediaType,
                    url: d.key
                }));
            }

            // 3️⃣ Send final payload
            const payload =
            {
                trigger: "FOLLOW",
                price: selectedCoin,
                payload: {
                    text: message,
                    media: [
                        ...existingMedia.map(m => ({
                            type: m.type,
                            url: removeBaseUrl(m.url),
                        })),
                        ...uploadedMedia.map(m => ({
                            type: m.type,
                            url: m.url,
                        }))
                    ]
                }
            };

            console.log("Payload ", payload);

            if (messageId) {
                UpdateWelcomeMessage(messageId, payload)
                    .then((res) => {
                        console.log("UpdateWelcomeMessage ", res?.data);
                        fetchWelcomeMessage();
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            }
            else {
                CreateWelcomeMessage(payload)
                    .then((res) => {
                        console.log("CreateWelcomeMessage ", res?.data);
                        fetchWelcomeMessage();
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            }

            console.log("Welcome Message completed >>> ");
        } catch (err) {
            showError("Media upload failed");
        }
    };

    const fetchWelcomeMessage = async () => {

        const res = await GetWelcomeMessage();
        const data = res?.data?.[0];

        if (!data) return;

        const apiMedia = data?.payload?.media;
        console.log("Media Length ", apiMedia?.length);

        const uiMedia = mapApiMediaToUiMedia(apiMedia);

        const snapshot = {
            message: data?.payload?.text || "",
            price: data?.price || null,
            media: uiMedia.map(m => ({
                type: m.type,
                url: m.url,
                isUploaded: m.isUploaded
            }))
        };

        setMessageId(data?.id);
        setMessage(snapshot.message);
        setSelectedCoin(snapshot.price);
        setMedia(uiMedia);
        setMediaType(uiMedia[0]?.type || null);

        setInitialData(snapshot);
    };

    const mapApiMediaToUiMedia = (apiMedia = []) => {
        return apiMedia.map(item => ({
            type: item.type,
            url: item.url,
            isUploaded: true
        }));
    };

    const isDirty = useMemo(() => {

        if (!initialData) {
            return (
                message.trim().length > 0 &&
                !!selectedCoin &&
                media.length > 0
            );
        }

        const messageChanged = message !== initialData.message;
        const priceChanged = selectedCoin !== initialData.price;

        const mediaChanged =
            media.length !== initialData.media.length ||
            media.some((m, i) =>
                m.type !== initialData.media[i]?.type ||
                m.url !== initialData.media[i]?.url
            );
        console.log("messageChanged ", messageChanged);
        console.log("priceChanged ", priceChanged);
        console.log("mediaChanged ", mediaChanged);

        return messageChanged || priceChanged || mediaChanged;
    }, [message, selectedCoin, media, initialData]);

    return (
        <div className="min-h-screen w-full bg-black flex justify-center">

            <div className="max-w-[420px] mx-auto min-h-screen bg-black font-sans py-20">

                {/* Select Media */}
                <div className="bg-white m-3 p-4 rounded-xl">
                    <h4 className="font-medium">Select Media:</h4>
                    <p className="text-sm text-gray-500">
                        {media.length} media selected.
                    </p>

                    <div className="flex gap-3 mt-3">
                        <label className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center text-3xl cursor-pointer">
                            +
                            <input
                                type="file"
                                hidden
                                multiple
                                accept="image/*,video/*"
                                onChange={handleMediaAdd}
                            />
                        </label>

                        {media.map((item, index) => (
                            <div key={index} className="relative">
                                {item.type === "image" ? (
                                    <img
                                        src={item.url}
                                        alt="media"
                                        className="w-16 h-16 rounded-lg object-cover"
                                    />
                                ) : (
                                    <video
                                        src={item.url}
                                        className="w-16 h-16 rounded-lg object-cover"
                                        preload="metadata"
                                        muted
                                    />
                                )}

                                <button
                                    onClick={() => removeMedia(index)}
                                    className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-xs flex items-center justify-center"
                                >
                                    <IoClose />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Select Gift */}
                <div className="bg-white m-3 p-4 rounded-xl flex justify-between items-center">
                    <div>
                        <h4 className="font-medium">Select Gift:</h4>
                        {selectedCoin &&
                            <div className="flex items-center gap-1">
                                <img src="./images/goldcoin.png" alt="coin" className="w-4 h-4 rounded-full object-cover" />
                                <p className="text-sm">{selectedCoin}</p>
                            </div>
                        }
                    </div>
                    <button
                        onClick={OnSelectClick}
                        className="bg-red-500 text-white px-5 py-1.5 rounded-full text-sm">
                        Select
                    </button>
                </div>

                {/* Message */}
                <div className="bg-white m-3 p-4 rounded-xl">
                    <h4 className="font-medium mb-2">Set Your Message:</h4>
                    <textarea
                        value={message}
                        maxLength={maxChars}
                        placeholder="Describe your engaging content"
                        onChange={(e) => setMessage(e.target.value)}
                        className="w-full h-24 border rounded-lg p-2 text-sm outline-none focus:ring-1 focus:ring-red-500 resize-none"
                    />
                    <div className="text-right text-xs text-gray-500 mt-1">
                        {message.length}/{maxChars}
                    </div>
                </div>

                {/* How it works */}
                <div className="bg-white m-3 p-4 rounded-xl">
                    <button
                        onClick={() => setOpen(!open)}
                        className="w-full flex items-center justify-between text-left"
                    >
                        <span className="font-sm">How it Works?</span>

                        <FaChevronRight
                            className={`transition-transform duration-300 ${open ? "rotate-90" : ""
                                }`}
                        />
                    </button>

                    <div
                        onClick={() => setOpen(!open)}
                        className={`overflow-hidden cursor-pointer transition-all duration-300 ${open ? "max-h-40 mt-3" : "max-h-0"
                            }`}
                    >
                        <p className="text-sm text-black leading-relaxed">
                            When a user follows you or interacts with you for the first time, the message you’ve prepared will be sent
                            automatically.
                            To increase your earnings, write an engaging welcome message, select
                            your best content, and activate automatic messages.
                        </p>
                    </div>
                </div>

                {/* Save Button */}
                <div className="max-w-[420px] mx-auto p-4">
                    <button
                        onClick={OnSaveClick}
                        disabled={!isDirty}
                        className={`w-full py-3 rounded-full font-medium text-white transition-all
                                ${isDirty
                                ? "bg-red-500 active:scale-95"
                                : "bg-gray-400 cursor-not-allowed"
                            }
                            `}
                    >
                        Save
                    </button>
                </div>
            </div>

            {showCoinSelection &&
                <SelectWelcomeGift
                    onClose={() => setshowCoinSelection(false)}
                    selectedCoin={selectedCoin}
                    onSelect={(coin) => OnCoinSelected(coin)}
                />
            }
        </div>
    );
}